import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { useSelector } from 'react-redux';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { AppStore } from '../../../store/store';
import CerrarSesion from '../CerrarSesion/CerrarSesion';
import { Link } from 'react-router-dom';

export type NavbarProps = {
	toggleSidebar: () => void;
};

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {

	const auth = useSelector((store: AppStore) => store.auth);

	return (
		<div className="navbar p-4 border-slate-200 border-b-2">
			<div className="flex-1">
				<div className='lg:hidden ml-4'>
					<button onClick={toggleSidebar}>
						<FontAwesomeIcon icon={faBars} />
					</button>
				</div>
				<div className='flex gap-1 items-end ml-5'>
					<Link to={`/`}>
						<img src={"https://cronos.gdar.mx/publico/assets/images/brand/logoDAR_Color.png"} alt="Mandaditos" className='lg:h-10 md:h-10 h-10' />
					</Link>
					
					{/* <img src={text} alt="Mandaditos" className='flex lg:h-5 md:h-4 h-4 align-bottom' /> */}
				</div>
			</div>
			<div className="flex-none gap-2">
				<div className='lg:flex md:flex hidden flex-col rounded-xl p-2 text-xs font-medium items-end'>
					<h1>
						{
							auth.correo
						}
					</h1>
					<hr />
					<h1>
						{
							auth.nombreUsuario
						}
					</h1>
				</div>
				<div className="dropdown dropdown-end">
					<div tabIndex={0} role="button" className="btn btn-ghost btn-circle avatar">
						<div className="flex rounded-full border-2 border-r-indigo-600 p-2 ">
							<FontAwesomeIcon icon={faUser} />
						</div>
					</div>
					<ul tabIndex={0} className="p-2 shadow menu dropdown-content bg-base-100 rounded-box w-52 z-50 border-gray">
						<li>
							<CerrarSesion/>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

export default Navbar;
